import { render } from "./UpdateTableItem.vue?vue&type=template&id=d84a9f2a&ts=true"
import script from "./UpdateTableItem.vue?vue&type=script&lang=ts"
export * from "./UpdateTableItem.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__